import { render, staticRenderFns } from "./Radar.vue?vue&type=template&id=13bfa998&scoped=true&"
import script from "./Radar.vue?vue&type=script&lang=js&"
export * from "./Radar.vue?vue&type=script&lang=js&"
import style0 from "./Radar.vue?vue&type=style&index=0&id=13bfa998&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfa998",
  null
  
)

export default component.exports